import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const AvatarSolid = (props: ISnapIcon) => {
  const { size, title, color = 'none' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 64 64'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <rect width='64' height='64' rx='32' fill='#F8FAFC' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.38673 49.7748C8.01195 47.3708 10.944 45.3253 14.1116 43.6993C19.6686 40.8469 25.7974 39.3644 32.0108 39.3697C42.2258 39.3697 51.5491 43.3004 58.6184 49.7675C52.8788 58.3492 43.0994 64 32.0001 64C20.904 64 11.127 58.3524 5.38673 49.7748ZM39.5479 30.6873C41.5483 28.6344 42.6721 25.8501 42.6721 22.9468C42.6721 20.0435 41.5483 17.2592 39.5479 15.2062C37.5475 13.1533 34.8344 12 32.0055 12C29.1765 12 26.4634 13.1533 24.463 15.2062C22.4626 17.2592 21.3388 20.0435 21.3388 22.9468C21.3388 25.8501 22.4626 28.6344 24.463 30.6873C26.4634 32.7403 29.1765 33.8936 32.0055 33.8936C34.8344 33.8936 37.5475 32.7403 39.5479 30.6873Z'
        fill='#CBD5E1'
      />
    </svg>
  );
};
